$(function () {
    $('[data-toggle="popover"]').popover({
        container: 'body'
    })
})
